import { Box } from "@mui/material";
import type { JSX } from "react";

import { PrioritiesEditor } from "./workflows/PrioritiesEditor.js";
import { StatusesEditor } from "./workflows/StatusesEditor.js";

/**
 * Workflows live inside Settings now — the ticket pipeline (statuses)
 * and urgency tiers (priorities) are tuned together here so SLA, kanban
 * board and reports stay coherent. The two editors share the same
 * row + form pattern and post through the audited support proxy.
 *
 * This file just composes the two editors; each lives under `workflows/`
 * as its own orchestrator (`StatusesEditor` / `PrioritiesEditor`) with a
 * colocated row (`StatusRow` / `PriorityRow`) + create dialog
 * (`NewStatusDialog` / `NewPriorityDialog`), and the shared grid templates
 * in `grids.ts`. Create flows open a modal; delete flows go through
 * ConfirmDialog; bulk-delete fans out per-row admin DELETEs via
 * `Promise.allSettled` (no `bulk_destroy` endpoint here yet).
 */
export function SettingsWorkflowsPanel(): JSX.Element {
  return (
    <Box sx={{ display: "grid", gap: 4 }}>
      <StatusesEditor />
      <PrioritiesEditor />
    </Box>
  );
}
